
import { defineComponent,ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import useWrapper from "./useTicket"
import {useStore} from "vuex"

export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const router = useRouter()
    const html = ref(null)
    const store = useStore()
    const baseUrl = process.env.VUE_APP_BASE_URL
    const {rawData,getTicket} = useWrapper()
    const d = new Date();
    const yeah = d.getFullYear()
    //*********** definning variables end **********//
    //*********** initData start **********//
    // if(store.state.userInfo.IsSure){
    //   getTicket()
    // }
    getTicket()
    
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    function handlePrint(){
      router.push({path:'/ticket_result'})
    }
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),
      handlePrint,html,baseUrl,yeah
      }
  },
});
